module.exports = __webpack_public_path__ + "img/shay_yes.16471b4a.png";